import { fontWeights } from "../../tokens/typography";
import { body1Styles, body2Styles, body3Styles } from "../../presets/typography";
import { colors } from "../../tokens/color";
import { getRgbaColor } from "../../shared/utils/color/color";
export const sizeStyles = {
    micro: {
        padding: '0.4rem 1.2rem',
        ...body3Styles,
    },
    small: {
        padding: '0.8rem 1.2rem',
        ...body2Styles,
    },
    medium: {
        padding: '1.2rem 2.4rem',
        ...body2Styles,
    },
    large: {
        padding: '1.6rem 2.4rem',
        ...body1Styles,
    },
};
const colorStyles = {
    whiteSecondary: {
        color: colors.text.inverseActivePrimary,
        '&:hover:not([data-disabled])': {
            boxShadow: 'inset 0 0 0 2px currentColor',
        },
    },
    blueSecondary: {
        color: colors.text.activePrimary,
        '&:hover:not([data-disabled])': {
            color: colors.text.activeSecondary,
            boxShadow: 'inset 0 0 0 2px currentColor',
        },
    },
    whiteFloating: {
        color: colors.text.inverseActivePrimary,
        '&:hover:not([data-disabled])': {
            boxShadow: 'inset 0 0 0 1px currentColor',
        },
    },
    blueFloating: {
        color: colors.text.activePrimary,
        '&:hover:not([data-disabled])': {
            boxShadow: 'inset 0 0 0 1px currentColor',
            color: colors.text.activeSecondary,
        },
    },
    whiteGhost: {
        color: colors.text.inverseActivePrimary,
        '&:hover:not([data-disabled])': {
            background: getRgbaColor(colors.text.inverseActivePrimary, 0.2),
        },
    },
    blueGhost: {
        color: colors.text.activePrimary,
        '&:hover:not([data-disabled])': {
            background: colors.action.active,
            color: colors.text.activeSecondary,
        },
    },
    whiteLink: {
        color: colors.text.inverseActivePrimary,
    },
    blueLink: {
        color: colors.text.activePrimary,
    },
};
export function getVariantStyles(variant, color, isSelected) {
    const variantStyles = {
        primary: {
            color: colors.text.inverseActivePrimary,
            background: colors.action.innovation,
            '&:hover:not([data-disabled])': {
                background: colors.action.innovationDark,
            },
            '&[data-disabled]': {
                background: colors.action.disabled,
            },
        },
        secondary: {
            boxShadow: 'inset 0 0 0 1px currentColor',
            background: colors.transparent,
            ...(color === 'white' ? colorStyles.whiteSecondary : colorStyles.blueSecondary),
            ...(isSelected ? getSelectedStyles(variant, color) : {}),
            '&[data-disabled]': {
                background: colors.action.disabled,
                boxShadow: 'none',
            },
        },
        tertiary: {
            background: colors.action.paleGray,
            color: colors.text.secondary,
            '&:hover:not([data-disabled])': {
                background: colors.action.lightGray,
            },
            '&[data-disabled]': {
                background: colors.action.disabled,
            },
        },
        floating: {
            background: colors.transparent,
            ...(color === 'white' ? colorStyles.whiteFloating : colorStyles.blueFloating),
        },
        ghost: {
            ...(color === 'white' ? colorStyles.whiteGhost : colorStyles.blueGhost),
            ...(isSelected ? getSelectedStyles(variant, color) : {}),
        },
        link: {
            ...(color === 'white' ? colorStyles.whiteLink : colorStyles.blueLink),
            padding: 0,
            '&:hover:not([data-disabled])': {
                textDecoration: 'underline',
            },
        },
    };
    return variantStyles[variant];
}
export function getWidthStyles(fullWidth) {
    return {
        width: fullWidth ? '100%' : 'auto',
    };
}
export function getFocusStyles(color, variant) {
    const whiteStyleSupported = variant !== 'primary' && variant !== 'tertiary';
    return {
        '&:focus-visible': {
            outline: `2px solid ${color === 'white' && whiteStyleSupported ? colors.border.inversePrimary : colors.border.activePrimary}`,
            outlineOffset: '3px',
        },
    };
}
export function getSelectedStyles(variant, color) {
    const selectedStyles = {
        primary: {},
        secondary: {
            boxShadow: 'inset 0 0 0 2px currentColor',
            background: color === 'blue' ? colors.action.active : getRgbaColor(colors.background.white, 0.15),
        },
        tertiary: {},
        floating: {},
        ghost: {
            boxShadow: 'inset 0 0 0 1px currentColor',
            background: color === 'blue' ? colors.action.active : getRgbaColor(colors.background.white, 0.2),
        },
        link: {},
    };
    return {
        color: color === 'blue' ? colors.text.activeSecondary : colors.text.inversePrimary,
        '&:not([data-disabled])': selectedStyles[variant],
    };
}
export const buttonBaseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontWeight: fontWeights.medium,
    userSelect: 'none',
    position: 'relative',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    borderRadius: '4px',
    transition: 'background-color 300ms ease, box-shadow 300ms ease, color 300ms ease',
    border: 0,
    outline: 0,
    background: 'none',
    textDecoration: 'none',
    '& svg': {
        height: '1em',
        width: '1em',
        color: 'currentcolor',
        '& path': {
            fill: 'currentcolor',
        },
    },
    '&[data-disabled]': {
        pointerEvents: 'none',
        color: colors.text.disabled,
    },
};
